//layoyt.js
export const SET_LAYOUT = 'SET_LAYOUT'
export const SET_LOADING = 'SET_LOADING'
export const TOGGLE_BAR = 'TOGGLE_BAR'

// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

//
export const FETCH_SERVICIOS = 'FETCH_SERVICIOS'
export const FETCH_CUENTAS = 'FETCH_CUENTAS'